
import StackedBarChart from "../Charts/StackedBarChart";
import SaveNewSegmnetModal from "../Segment/SaveNewSegmentModal";
import Chip from "./Chip";
import SegmentProvider, { SegmentContext } from "../Segment/SegmentContext";
import DemoOpenSegment from "../Segment/DemoOpenSegment";
import DemoArrayofSegments from "../Segment/DemoArrayOfSegments";

const data = [
  {
    name: "Free phone",
    Answered: 566,
    Missed: 98,
  },
  {
    name: "High rate line",
    Answered: 0,
    Missed: 0,
  },
  {
    name: "Internatonal",
    Answered: 302,
    Missed: 22,
  },
  {
    name: "Local",
    Answered: 1672,
    Missed: 597,
  },
  {
    name: "Mobile",
    Answered: 19479,
    Missed: 5994,
  },
  {
    name: "National",
    Answered: 16665,
    Missed: 3192,
  },
  {
    name: "One phone",
    Answered: 2,
    Missed: 1,
  },
  {
    name: "Special service",
    Answered: 38,
    Missed: 1,
  },
  {
    name: "Other",
    Answered: 133,
    Missed: 16,
  },
];

const defaultChipHeaders: string[] = ["Tab 1", "Tab 2"];

const defaultChipContent: React.ReactNode[] = [
  <StackedBarChart data={data} />,

];

export default function ChipDemo() {

  return (
    <SegmentProvider>
    <div className="page-content">
      
      {/* <Chip
        tabNavHeaderItems={defaultChipHeaders}
        tabContentItems={defaultChipContent}
        hasStatusCircle={false}
      /> */}
      
      <DemoOpenSegment />
      <SaveNewSegmnetModal />
      <DemoArrayofSegments />
      
    </div>
    </SegmentProvider>
  );
}
